module.exports = __webpack_public_path__ + "static/media/carousel4bg.40527f23.png";